import { render, staticRenderFns } from "./NotificationsDropdown.vue?vue&type=template&id=f1954a10&scoped=true&"
import script from "./NotificationsDropdown.vue?vue&type=script&lang=ts&"
export * from "./NotificationsDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsDropdown.vue?vue&type=style&index=0&id=f1954a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1954a10",
  null
  
)

export default component.exports